import PendoDrawer from '../../../components/drawer/pendo-drawer.vue.js';
import NoteDrawerContent from './notes/note-drawer-content.vue.js';
import UserImpactDrawerContent from './user-impact/user-impact-drawer-content.vue.js';

var script = {
  name: 'GuideAlertsDrawer',
  components: {
    PendoDrawer,
    NoteDrawerContent,
    UserImpactDrawerContent
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    isTypeNote: {
      type: Boolean,
      required: true
    },
    activeUser: {
      type: Object,
      required: true
    },
    displayAlert: {
      type: Object,
      default: () => {}
    },
    noteAction: {
      type: Object,
      default: () => {}
    },
    noteError: {
      type: Object,
      default: () => {}
    },
    hasAdminAccess: {
      type: Boolean,
      default: false
    },
    impactedUsers: {
      type: Array,
      default: () => []
    },
    guideVisitorAggStatus: {
      type: String,
      required: true
    },
    csvAggState: {
      type: Object,
      default: () => ({})
    },
    productType: {
      type: String,
      required: true
    }
  },
  computed: {
    title() {
      return this.isTypeNote ? 'Guide Activity' : 'Visitors Impacted';
    }
  }
};

export { script as default };
//# sourceMappingURL=guide-alerts-drawer.vue2.js.map
